import RootLanding from '../../components/layouts/RootLanding';
import useSWR from 'swr';
import { useEffect, useState, useRef } from 'react';
import { HIGHCHART_URL, getFetcherJariEmas, getFetcherProvinceJariEmas, getFetcherPublic } from '../../services/api';
import banner from '../../assets/banner/bg-jari-emas.jpg';
import logo_brin from '../../assets/images/brin-logo.png';
import logo_gef from '../../assets/images/gef-logo.png';
import logo_undf from '../../assets/images/undf-logo.svg';
import { Button, Card, CardBody, CardFooter, CardHeader, Divider, Radio, RadioGroup, Snippet } from '@nextui-org/react';
import FilterReactSelect from '../../components/elements/FilterReactSelect';
import { BarChart, LineChart } from '@mui/x-charts';
import ReactMapGL from 'react-map-gl';
import { ArrowDownTrayIcon, ArrowPathIcon } from '@heroicons/react/24/outline';
import playstore from '../../assets/images/playstore.png';
import mobile_app from '../../assets/images/mobile-app.png';
import manual from '../../assets/images/manual.png';
import { allProvinces } from '../../services/helpers';
import Highcharts from "highcharts";
import HighchartsReact from 'highcharts-react-official';
import highchartsExporting from 'highcharts/modules/exporting';

// Initialize Highcharts exporting modules
highchartsExporting(Highcharts);

export default function Jariemas() {
    const defaultLocation = {
        latitude: -2.600029,
        longitude: 118.015776,
        zoom: 4.2,
    }
    const mapContainer = useRef(null);
    const map = useRef(null);
    const [filter, setFilter] = useState(null);
    const [chartType, setChartType] = useState('bar');
    const {data, isLoading} = useSWR('/api/v1/provinces', getFetcherProvinceJariEmas);
    const [viewport, setViewport] = useState(defaultLocation);
    const [selectedProvince, setSelectedProvince] = useState(null);

    const { data: dataMekuri, isLoading: isLoadingMerkuri}  = useSWR(filter?.value ? `/api/v1/mercury-avoided/chart?inYear=true&provinceId=${filter.value}` : `/api/v1/mercury-avoided/chart?inYear=true`, getFetcherJariEmas);
    const { data: dataMaps, isLoading: isLoadingMaps}  = useSWR(`/api/v1/mercury-avoided/map`, getFetcherJariEmas);
      
      

    return (
        <RootLanding>
            <section key="banner" className='relative w-full h-[70vh] mx-auto'>
                <div className='absolute inset-0'>
                    <img alt="bg-login" src={banner} className="w-full h-full object-cover" />
                </div>
                <div className='absolute inset-0 bg-gradient-to-r from-gray-500 via-black via-50% to-gray-700 opacity-70'></div>
                <div className="h-full relative z-10 flex flex-col items-center justify-center text-center text-white">
                    <div className='max-w-screen-md lg:max-w-screen-lg mx-auto py-10 xl:py-0 px-3 md:px-5'>
                        <p className="text-2xl md:text-4xl lg:text-6xl font-semibold mb-5">Selamat Datang di Jari Emas</p>
                        <p className="text-xs md:text-sm mb-10">
                            Proyek Global Environment Facility – Global Opportunities for Long-term Development of Artisanal and Small-scale Gold Mining Sector (GEF- GOLD): Integrated Sound Management of Mercury in Indonesia’s ASGM (“GOLD-ISMIA”) salah satu tujuannya adalah untuk mendukung 6 (enam) lokasi pertambangan emas skala kecil (PESK) di Indonesia dalam mengurangi atau menghindari penggunaan merkuri setidaknya hingga 5 ton per tahun mulai dari tahun ke-3 proyek. Selama durasi proyek, target penghindaran merkuri dapat mencapai lebih dari 15 ton. Untuk mendukung tujuan ini, tim Proyek GOLD ISMIA mengembangkan aplikasi berbasis mobile dan portal data berbasis web yaitu Aplikasi Jari Emas, agar dapat memonitor penghindaran merkuri secara sistematis dan regular.
                        </p>
                    
                        <div className="relative flex items-center mb-5">
                            <div className="flex-grow border-t border-line-strong"></div>
                            <span className="flex-shrink mx-4 text-ink-400 italic text-sm">associated with</span>
                            <div className="flex-grow border-t border-line-strong"></div>
                        </div>
                        <div className='flex gap-5 items-center justify-center'>
                            <div className='bg-white p-0.5'>
                                <img alt="logo-brin" src={logo_brin} className="w-11 h-16" />
                            </div>
                            <img alt="logo-gef" src={logo_gef} className="w-11 h-16" />
                            <img alt="logo-gef" src={logo_undf} className="w-11 h-16" />
                        </div>
                    </div>
                </div>
            </section>
            <section key="chart" className="px-5 md:px-10 lg:px-20 pt-10">
                <Card radius='sm'>
                    <CardHeader className='text-lg font-semibold'>Total Merkuri Terhidarkan dari Pertambangan Emas Skala Kecil Batuan Primer di Seluruh Indonesia</CardHeader>
                    <CardBody>
                        <div className='flex justify-end mb-10'>
                            <div className='w-full md:w-1/2 lg:w-1/4'>
                                <FilterReactSelect
                                    options={data}
                                    isLoading={isLoading}
                                    defaultValue={filter}
                                    setValue={setFilter}
                                    menuPosition='absolute'
                                    placeholder="Seluruh Indonesia"
                                />
                            </div>
                        </div>
                        <div className='w-full grid grid-cols-1 md:grid-cols-4 gap-3 mb-10'>
                            <div className='col-span-4 lg:col-span-1 flex flex-col md:flex-row lg:flex-col gap-3'>
                                <Card radius='sm' className='w-full'>
                                    <CardBody className='m-3'>
                                        <span className='text-3xl font-semibold text-ink-500'> {dataMekuri?.data?.summary?.totalProductInTon?.toFixed(2)} ton</span>
                                        <span className='text-ink-400'>Batu yang diolah</span>
                                    </CardBody>
                                </Card>
                                <Card radius='sm' className='w-full'>
                                    <CardBody className='m-3'>
                                        <span className='text-3xl font-semibold text-blue-500'>{dataMekuri?.data?.summary?.totalMercuryAvoided?.toFixed(2)}  TON</span>
                                        <span className='text-ink-400'>Perkiraan merkuri terhindarkan</span>
                                    </CardBody>
                                </Card>
                            </div>
                            <div className='col-span-4 lg:col-span-3'>
                                <Card radius='sm'>
                                    <CardHeader className='w-full flex justify-end'>
                                        <RadioGroup onValueChange={setChartType} value={chartType} orientation="horizontal">
                                            <Radio value="line">Line Chart</Radio>
                                            <Radio value="column">Bar Chart</Radio>
                                        </RadioGroup>
                                    </CardHeader>
                                    <Divider/>
                                    <CardBody>
                                    {dataMekuri?.data?.mercuryAvoided?.length > 0 ? (
                                        <HighchartsReact
                                        highcharts={Highcharts}
                                        options={{
                                            chart: {
                                            type: chartType, // Menggunakan nilai 'line' atau 'bar' dari state
                                            },
                                            title: {
                                            text: "Total Merkuri Terhindarkan",
                                            },
                                            xAxis: {
                                            categories: dataMekuri.data.mercuryAvoided.map((item) => item.onDate.toString()),
                                            title: {
                                                text: "Tahun",
                                            },
                                            },
                                            yAxis: {
                                            min: 0,
                                            title: {
                                                text: "Total Merkuri Terhindarkan (Ton)",
                                            },
                                            },
                                            series: [
                                            {
                                                name: "Total Merkuri",
                                                data: dataMekuri.data.mercuryAvoided.map((item) => parseFloat(item.totalMercuryAvoided.toFixed(2))),
                                            },
                                            ],
                                            tooltip: {
                                            formatter: function () {
                                                return `<b>${this.x}</b>: ${this.y.toLocaleString()} Ton`;
                                            },
                                            },
                                            legend: {
                                            enabled: true,
                                            },
                                            exporting: {
                                                url: HIGHCHART_URL,
                                                enabled: true,
                                                showTable: true,
                                            },
                                        }}
                                        />
                                    ) : (
                                        <p className="text-center text-ink-500">Tidak ada data untuk grafik.</p>
                                    )}
                                    </CardBody>
                                </Card>
                            </div>
                        </div>
                        <div className='w-full md:w-1/2 flex flex-col gap-1'>

                        </div>
                    </CardBody>
                    <CardFooter></CardFooter>
                </Card>
            </section>
            <section key="map" className="px-5 md:px-10 lg:px-20 pt-10">
            <Card radius="sm">
                <div className="w-full flex flex-col items-center relative overflow-hidden">
                    <iframe 
                        className='w-full h-[90vh]'
                        src="https://jariemas.menlhk.go.id/embed/map" 
                        title="Avoided Mercury Indonesian Map" 
                        allowFullScreen
                    />
                </div>
            </Card>
            </section>

            <section className='w-full h-full grid grid-cols-1 lg:grid-cols-2 pt-10'>
                <div className='flex flex-col md:flex-row text-[#00453F] items-center px-5 md:px-10 lg:px-20 bg-primary py-5 gap-5'>
                    <div className='w-full md:w-1/3 flex justify-center md:justify-end'>
                        <img alt="play-store" src={mobile_app} className='w-1/2 md:w-full' />              
                    </div>
                    <div className='w-full md:w-2/3 flex flex-col text-center md:text-start items-center md:items-start'>
                        <span className='text-xl font-semibold'>Mulai pencatatan pertambangan daerah anda sekarang.</span>
                        <span>Temukan aplikasi Jari Emas di Play Store</span>
                        <img alt="play-store" src={playstore} className='w-2/5 md:w-1/4 lg:w-2/6 pt-5' />
                    </div>
                </div>
                <div className='flex flex-col md:flex-row-reverse lg:flex-row text-[#00453F] items-center px-5 md:px-10 lg:px-20 bg-white py-5 gap-5'>
                    <div className='w-full md:w-1/3 hidden md:flex justify-center md:justify-end'>
                        <img alt="play-store" src={manual} className='w-2/3 md:w-full' />              
                    </div>
                    <div className='w-full md:w-2/3 flex flex-col text-center md:text-start'>
                        <span className='text-xl font-semibold'>Pelajari cara penggunaan aplikasi</span>
                        <div className='mt-3'>
                            <a href='https://jariemas.menlhk.go.id/usermanual.pdf' target='_blank'>
                                <Button size='sm' color='primary' radius='full' startContent={<ArrowDownTrayIcon className="size-4" />}>Unduh Buku Panduan (1 MB)</Button>
                            </a>
                        </div>
                    </div>
                </div>
            </section>
        </RootLanding>    
    )
}
